var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUxerSimple({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "Iconz/uxer_simple"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4.339 10.053V9.64C4.339 5.42 7.762 2 11.986 2c4.223 0 7.647 3.42 7.647 7.639v.414m-15.294 0h-.173c-1.768 0-3.166 1.47-3.166 3.24 0 1.77 1.398 3.24 3.166 3.24h.21C4.764 20.013 8.05 23 11.987 23c3.935 0 7.222-2.988 7.609-6.467h.24c1.767 0 3.165-1.47 3.165-3.24 0-1.77-1.398-3.24-3.166-3.24h-.201m-15.294 0v6.48m15.294-6.48v6.48m-3.288-1.666c1.337 1.45.49 4.133-1.305 4.133l-3.06-3.848L8.947 19c-1.788 0-2.627-2.675-1.29-4.111l1.844-1.98-1.573-1.736C6.59 9.697 7.453 7 9.263 7l2.717 3.685L14.697 7c1.823 0 2.7 2.708 1.361 4.207l-1.52 1.702 1.807 1.958Z",
    className: "iconz"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxerSimple);
export default __webpack_public_path__ + "static/media/uxer_simple.c3d6b38508191151f7f93ba10186e500.svg";
export { ForwardRef as ReactComponent };